import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import Button from "shared/components/Button/Button"
import openZendeskChat from "shared/services/zendesk/openZendeskChat"

import styles from "./Contact.module.css"

const cx = classNames.bind(styles)

const Contact = props => {
  const { t: translate } = useTranslate()
  const { lang } = props

  return (
    <footer className={cx(styles.contactFooter, "w300", "fs-16")}>
      {translate("Need more information?")}
      <section className="m-t-20">
        <Button
          onClick={() => openZendeskChat(lang)}
          className={styles.contactBtn}
          variation="primary"
          buttonType="border"
        >
          {translate("Contact sales team")}
        </Button>
      </section>
    </footer>
  )
}

Contact.propTypes = {
  lang: PropTypes.string.isRequired,
}

export default Contact
